import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
    Typography,
    Box,
    CircularProgress,
} from '@mui/material'

const EmailConfirmationDialog = ({
    open,
    onClose,
    emailType,
    onConfirm,
    toEmails = [],
    ccEmails = [],
    isLoading = false,
    error = null,
    isSending = false,
    confirmationMessage = null,
    onCancelProcess = null
}) => {
    const renderEmailList = (emails, title) => {
        if (!emails || emails.length === 0) return null;

        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {title}:
                </Typography>
                <List
                    sx={{
                        maxHeight: '150px',
                        overflow: 'auto',
                        bgcolor: 'background.paper',
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        borderRadius: 1,
                    }}
                >
                    {emails.map((email, index) => (
                        <ListItem key={index} divider={index !== emails.length - 1}>
                            <ListItemText primary={typeof email === 'object' ? email.email : email} secondary={typeof email === 'object' ? email.name : null} />
                        </ListItem>
                    ))}
                </List>
            </Box>
        );
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                {emailType === 'team' ? 'Send Invoice to Team' : 'Send Invoice to Customer'}
            </DialogTitle>
            {/* Confirmation message based on type */}
            <Box sx={{ px: 3, pt: 1 }}>
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                    {confirmationMessage || (emailType === 'team'
                        ? 'Are you sure you want to send the invoice to the team?'
                        : 'Are you sure you want to send the invoice to the customer?')}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    This action can be undone.
                </Typography>
            </Box>
            <DialogContent>
                {isLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Typography color="error" sx={{ mb: 2 }}>
                        {error}
                    </Typography>
                ) : (
                    <>
                        {renderEmailList(toEmails, 'To')}
                        {renderEmailList(ccEmails, 'CC')}

                        {emailType !== 'customer' && (!toEmails || toEmails.length === 0) && (!ccEmails || ccEmails.length === 0) && (
                            <Typography color="warning.main">
                                No email recipients specified. Please add recipients before sending.
                            </Typography>
                        )}
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isSending}>
                    {isSending ? 'Sending...' : 'Close'}
                </Button>
                {isSending && onCancelProcess && (
                    <Button onClick={onCancelProcess} color="warning" variant="outlined">
                        Stop Process
                    </Button>
                )}
                {!isSending && (
                    <Button
                        onClick={onConfirm}
                        variant="contained"
                        color="primary"
                        disabled={
                            isLoading ||
                            error ||
                            (emailType !== 'customer' && (!toEmails?.length && !ccEmails?.length))
                        }
                    >
                        {isLoading ? 'Loading...' : 'Send'}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}

export default EmailConfirmationDialog
